import { useEffect, useCallback } from 'react';
import { dispatcher } from 'dispatcher';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

export const useLegacyBackButtonShowListener = () => {
    const dispatchPublicEvent = useCallback(() => {
        publicEventsAPIService.trigger('header:backButton:toggle');
    }, []);

    useEffect(() => {
        dispatcher.listen('backButton:show', dispatchPublicEvent);

        return () => {
            dispatcher.removeListener('backButton:show', dispatchPublicEvent);
        };
    }, [dispatchPublicEvent]);
};
